import React, { useRef } from 'react'
import ReactPlayer from 'react-player'

interface ChallengeDetailHeroProps {
    mainImage: string
    video?: {
        videoUrl: string
        videoThumbUrl: string
    }
    challengeUrl: string
}

export const ChallengeDetailHero = ({ mainImage, video }: ChallengeDetailHeroProps) => {
    const videoRef: any = useRef(null)

    return (
        <div className="max-w-screen-fullHd mx-auto">
            <div className="aspect-w-16 aspect-h-9 relative">
                {video !== null ? (
                    <ReactPlayer
                        ref={videoRef}
                        playIcon={
                            <i className="fas fa-play text-7xl text-white z-10"></i>
                        }
                        playing={true}
                        className="react-player"
                        width="100%"
                        height="100%"
                        url={video?.videoUrl}
                        light={video?.videoThumbUrl}
                        controls
                        onEnded={() => {
                            videoRef?.current?.showPreview()
                        }}
                    />
                ) : (
                    <img
                        src={mainImage}
                        alt="Exercise hero image"
                        className="object-center object-contain bg-gray-200"
                    />
                )}
            </div>
        </div>
    )
}
